import { useEffect, useState } from 'react';

import { axios } from '../api';

interface DisputeStatusResponse {
  has_dispute: boolean;
  status: string | null;
}

interface UseGetDisputeStatusResult {
  disputeStatus: string | null;
  isLoading: boolean;
  isError: boolean;
}

export const useGetDisputeStatus = (orderId: string | undefined): UseGetDisputeStatusResult => {
  const [disputeStatus, setDisputeStatus] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    setDisputeStatus(null);
    setIsError(false);

    if (!orderId) {
      setIsLoading(false);
      return;
    }

    let ignore = false;

    setIsLoading(true);

    axios
      .get<DisputeStatusResponse>(`disputes/order/${orderId}`)
      .then((response) => {
        if (ignore) return;
        if (response.data.has_dispute) {
          setDisputeStatus(response.data.status);
        }
      })
      .catch(() => {
        if (ignore) return;
        setIsError(true);
      })
      .finally(() => {
        if (ignore) return;
        setIsLoading(false);
      });

    return () => {
      ignore = true;
    };
  }, [orderId]);

  return {
    disputeStatus,
    isLoading,
    isError,
  };
};
